<template>
  <v-dialog v-model="openDialog" persistent max-width="800px">
    <v-card>
      <v-card-title class="mx-3 pl-6 pt-4">
        <span class="text-h5">Benutzer Rollen bearbeiten</span>
      </v-card-title>
      <v-divider class="mx-9 mb-5" />
      <v-card-text class="py-0">
        <v-row>
          <v-col>
            <v-text-field
              bg-color="accent"
              variant="filled"
              hide-details
              label="ID"
              readonly
              disabled
              v-model="userCopy.userId"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-list>
          <v-list-item-title
            :style="{
              backgroundColor:
                $vuetify.theme.global.name === 'dark' ? '#1e1e1e' : '',
            }"
          >
            <span class="text-h6">Rollen</span></v-list-item-title
          >
          <v-list-item v-for="(role, i) in roles" :key="i">
            <div class="d-flex align-center">
              <v-checkbox
                v-model="userCopy.roles"
                :value="role.id"
                hide-details
                density="compact"
              />
              <v-list-item-title class="ml-4">{{
                role.name
              }}</v-list-item-title>
            </div>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="outlined" @click="closeDialog">Abbrechen</v-btn>
        <v-btn
          class="mr-2"
          variant="flat"
          color="primary"
          @click="saveUserRoles"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TenantUserEditRoleDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      userCopy: {},
    };
  },
  watch: {
    user: {
      handler() {
        this.userCopy = JSON.parse(JSON.stringify(this.user));
      },
      immediate: true,
    },
  },
  computed: {
    openDialog: {
      get() {
        return this.open;
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    saveUserRoles() {
      this.$emit("save", this.userCopy.userId, this.userCopy.roles);
    },
  },
};
</script>

<style scoped></style>
